// 数据表
// 附带两列相同的数据
// 前端进行分页
<template>
  <div>
    <table class="data-table">
      <tr>
        <td>{{ titleX }}</td>
        <td>{{ titleY }}</td>
        <td>{{ titleX }}</td>
        <td>{{ titleY }}</td>
      </tr>
      <tr v-for="(item, index) in dataSourceXComputed" v-if="index % 2 === 0">
        <td>{{ item }}</td>
        <td>{{ dataSourceYComputed[index] }}</td>
        <td>{{ dataSourceXComputed[index + 1] }}</td>
        <td>{{ dataSourceYComputed[index + 1] }}
        </td>
      </tr>
    </table>
    <my-divider height="20px"></my-divider>
    <div style="text-align: right">
      <el-pagination @size-change="handleSizeChange($event)"
                     @current-change="handleCurrentChange($event)"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 30, 40]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalComputed">

      </el-pagination>
    </div>
  </div>
</template>

<script>
import MyDivider from "@/components/MyDivider";

export default {
  name: "DataTableWithTwoColumns",
  components: {MyDivider},
  created() {
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
    },

  },
  computed: {
    dataSourceXComputed() {
      let startIndex = this.pageSize * (this.currentPage - 1);
      let endIndex = startIndex + this.pageSize;

      return this.dataSourceX.slice(startIndex, endIndex);
    },
    dataSourceYComputed() {
      let startIndex = this.pageSize * (this.currentPage - 1);
      let endIndex = startIndex + this.pageSize;

      return this.dataSourceY.slice(startIndex, endIndex);
    },
    totalComputed(){
      return this.dataSourceX.length;
    }
  },
  props: {
    titleX: {
      type: String,
      default: '时间'
    },
    titleY: {
      type: String,
      default: '标题'
    },
    dataSourceX: {
      type: Array,
      default: () => []
    },
    dataSourceY: {
      type: Array,
      default: () => []
    }
  },

}
</script>

<style scoped lang="scss">
$borderColor: #eeeeee;

table.data-table {
  text-align: center;
  width: 100%;
  border-left: 1px solid $borderColor;
  border-top: 1px solid $borderColor;
  border-spacing: 0;

  tr {
    height: 50px;

    td {
      border-bottom: 1px solid $borderColor;
      border-right: 1px solid $borderColor;
    }
  }

  tr:first-child {
    td:first-child {
      width: 35%;
    }

    td:nth-child(3) {
      width: 35%;
    }
  }

  tr:hover {
    background-color: #F8F9FC;
  }
}
</style>
